var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosIllustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 594,
    height: 639,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-42.9%",
    y: "-38%",
    width: "185.7%",
    height: "175.9%",
    filterUnits: "objectBoundingBox",
    id: "b"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 50,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-28.1%",
    y: "-28.1%",
    width: "156.2%",
    height: "156.2%",
    filterUnits: "objectBoundingBox",
    id: "c"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-70.6%",
    y: "-70.6%",
    width: "241.2%",
    height: "241.2%",
    filterUnits: "objectBoundingBox",
    id: "d"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EA5E9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BAE6FD",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-422 -2927)",
    fill: "url(#a)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M286.04 19.22c74.64 46.968 85.528 164.69 24.342 263.158-61.303 98.461-171.592 140.279-246.339 93.402-74.746-46.876-85.645-164.696-24.342-263.158C101.004 14.161 211.293-27.657 286.04 19.22Zm-47.046 76.512c-42.544-26.681-105.319-2.88-140.211 53.163C63.89 204.938 70.093 272 112.638 298.68c42.544 26.682 105.319 2.88 140.211-53.163 34.827-56.046 28.629-123.051-13.855-149.785Z",
    filter: "url(#b)",
    transform: "translate(544 3049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 270c-35.346 0-64-28.654-64-64 0-35.346 28.654-64 64-64 35.346 0 64 28.654 64 64 0 35.346-28.654 64-64 64Zm0-16c26.51 0 48-21.49 48-48s-21.49-48-48-48-48 21.49-48 48 21.49 48 48 48Z",
    filter: "url(#c)",
    transform: "translate(544 3049)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151 235c-9.389 0-17-7.611-17-17s7.611-17 17-17 17 7.611 17 17-7.611 17-17 17Zm0-4c7.18 0 13-5.82 13-13s-5.82-13-13-13-13 5.82-13 13 5.82 13 13 13Z",
    filter: "url(#d)",
    transform: "translate(544 3049)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosIllustration);
export default __webpack_public_path__ + "static/media/logos-illustration.c11f8c9a1683be02b5716f04ff1f1841.svg";
export { ForwardRef as ReactComponent };